// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.didwallet",
    name: "DIDWallet",
    homepage: "https://www.didwallet.io/",
    image_id: "bc66fa57-46f4-4e17-6cb7-5f2d9af9c000",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/id1460083542",
        android: "https://play.google.com/store/apps/details?id=com.arcblock.wallet.app.product",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "abt://didwallet.io/i",
        universal: "https://didwallet.io/i",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map